import { useTranslation } from 'react-i18next';
import { Bag } from 'iconoir-react';
import { ProgramStatus } from '@fluenceur/types';
import { EmptyState } from '@/components/ui/empty-state';
import NewProgramButton from './NewProgramButton';

interface ProgramsEmptyStateProps {
  status: ProgramStatus;
  onCreate: () => void;
}

/** Shown when the filtered program list is empty, with a create CTA. */
const ProgramsEmptyState = ({ status, onCreate }: ProgramsEmptyStateProps) => {
  const { t } = useTranslation();
  const titleKey =
    status === ProgramStatus.Active
      ? 'programs.browse.empty.activeTitle'
      : 'programs.browse.empty.inactiveTitle';

  return (
    <EmptyState
      title={t(titleKey)}
      description={t('programs.browse.empty.description')}
      icon={<Bag />}
    >
      <NewProgramButton onClick={onCreate} />
    </EmptyState>
  );
};

export default ProgramsEmptyState;
